module.exports = __webpack_public_path__ + "img/23.53432a22.gif";